import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-eeo-data-request-template',
  styleUrls: ['../../global-styles.less', './eeo-data-request.component.less'],
  templateUrl: './eeo-data-request.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EeoDataRequestTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EeoDataRequestTemplateData>;
}

export type EeoDataRequestTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  footer_html: string;
  message: string;
  company_name: string;
};

export const EeoDataRequestTemplateMocks: EeoDataRequestTemplateData[] = [
  {
    company_name: 'White House',
    message:
      '<p>Hi Donald Trump,<br />Thank you for your interest in POTUS.</p>\n' +
      '<p>Since White House is committed to equal employment opportunity and nondiscrimination, federal law requires us to reach out to, hire, and provide equal opportunity to qualified people without regard to race, color, religion sex, national origin, age, veteran status, genetic information, disability or any legally protected status. We are also subject to certain nondiscrimination recordkeeping and reporting requirements which require us to invite employees to voluntarily self-identify their race/ethnicity and gender.</p>\n' +
      '<p>To help us be an equal opportunity employer <strong>please answer the self-identification questionnaire below</strong>. Submission of this information is <em>voluntary</em> and refusal to provide it will not subject you to any adverse treatment. The information provided will be used only in ways that are not inconsistent with the provisions of applicable laws, executive orders, and regulations.</p>',
    footer_html: 'Powered by Recruitee',
    // EEO survey box
    title: 'Self-identification questions',
    p1: 'Help us be an equal opportunity employer by providing answers.',
    button_text: 'Answer now',
    button_link: 'https://example.com',
  },
];
